import * as IconsDuotone from '@fortawesome/pro-duotone-svg-icons';
import * as IconsRegular from '@fortawesome/pro-regular-svg-icons';
import * as IconsSolid from '@fortawesome/pro-solid-svg-icons';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';


const getIcon = (iconClass: string): IconDefinition => {
  if (!iconClass) return fallbackIcon();
  if (iconClass.includes('fa-duotone')) return getIconDuotone(iconClass);
  if (iconClass.includes('fa-solid')) return getIconSolid(iconClass);
  else return getIconRegular(iconClass);
}

const getIconRegular = (iconClass: string): IconDefinition => {
  if (!iconClass) return fallbackIcon();

  const iconKey = extractIconKey(iconClass);

  if (iconKey in IconsRegular) {
    const regularIcon = IconsRegular[iconKey as keyof typeof IconsRegular];
    if (isIconDefinition(regularIcon)) {
      return regularIcon;
    }
  }

  return fallbackIcon();
};


const getIconDuotone = (iconClass: string): IconDefinition => {
  if (!iconClass) return fallbackIcon();

  const iconKey = extractIconKey(iconClass);

  if (iconKey in IconsDuotone) {
    const duotoneIcon = IconsDuotone[iconKey as keyof typeof IconsDuotone];
    if (isIconDefinition(duotoneIcon)) {
      return duotoneIcon;
    }
  }

  if (iconKey in IconsRegular) {
    const regularIcon = IconsRegular[iconKey as keyof typeof IconsRegular];
    if (isIconDefinition(regularIcon)) {
      return regularIcon;
    }
  }

  return fallbackIcon();
};

const getIconSolid = (iconClass: string): IconDefinition => {
  if (!iconClass) return fallbackIcon();

  const iconKey = extractIconKey(iconClass);

  if (iconKey in IconsSolid) {
    const solidIcon = IconsSolid[iconKey as keyof typeof IconsSolid];
    if (isIconDefinition(solidIcon)) {
      return solidIcon;
    }
  }

  if (iconKey in IconsRegular) {
    const regularIcon = IconsRegular[iconKey as keyof typeof IconsRegular];
    if (isIconDefinition(regularIcon)) {
      return regularIcon;
    }
  }

  return fallbackIcon();
};

const extractIconKey = (iconClass: string): string => {
  const sanitizedClass = iconClass.replace(/fa-(duotone|solid|regular)\s/g, '').trim();

  const iconMatch = sanitizedClass.match(/fa-(\S+)/);
  if (iconMatch) {
    return formatIconKey(iconMatch[1]);
  }

  return '';
};

const formatIconKey = (iconName: string): string => {
  return `fa${iconName
    .split('-')
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join('')}`;
};

const isIconDefinition = (icon: any): icon is IconDefinition => {
  return icon && typeof icon === 'object' && 'iconName' in icon;
};

const fallbackIcon = (): IconDefinition => IconsDuotone.faHouse;

export { getIcon, getIconDuotone, getIconRegular, getIconSolid };
